<script>
    export let isOpen;
    export let onClose;
    export let component;
    export let props;
</script>

<div
    class="modal"
    class:hidden={!isOpen}
    on:click={onClose}
>
    <svelte:component this={component} {...props}/>
</div>

<style>
    .modal {
        width: 100%;
        height: 100%;
        background-color: rgba(129, 129, 129, 0.596);
        position: absolute;
        top: 0px;
        left: 0px;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 30;
    }
    .hidden {
        display: none;
    }
</style>